const MIRROR_STYLES = [
  'direction', 'boxSizing', 'width', 'height', 'overflowX', 'overflowY',
  'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
  'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
  'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize',
  'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform',
  'textIndent', 'textDecoration', 'letterSpacing', 'wordSpacing', 'tabSize',
  'whiteSpace', 'wordWrap',
] as const;

export function getCaretCoordinates(textarea: HTMLTextAreaElement): { top: number; left: number } {
  const div = document.createElement('div');
  const style = div.style;
  const computed = getComputedStyle(textarea);

  style.position = 'absolute';
  style.visibility = 'hidden';
  style.whiteSpace = 'pre-wrap';
  style.wordWrap = 'break-word';

  for (const prop of MIRROR_STYLES) {
    style.setProperty(prop, computed.getPropertyValue(prop));
  }

  div.textContent = textarea.value.substring(0, textarea.selectionEnd);
  const span = document.createElement('span');
  span.textContent = '\u200b';
  div.appendChild(span);

  document.body.appendChild(div);
  const rect = textarea.getBoundingClientRect();
  const top = rect.top + span.offsetTop - textarea.scrollTop;
  const left = rect.left + span.offsetLeft - textarea.scrollLeft;
  document.body.removeChild(div);

  return { top, left };
}

export function extractMentionContext(textarea: HTMLTextAreaElement): { query: string; startIndex: number } | null {
  const pos = textarea.selectionEnd;
  const text = textarea.value.substring(0, pos);

  for (let i = text.length - 1; i >= 0; i--) {
    if (text[i] === '@') {
      if (i > 0 && !/\s/.test(text[i - 1])) return null;
      return { query: text.substring(i + 1, pos), startIndex: i };
    }
    if (/\s/.test(text[i])) return null;
  }

  return null;
}
